import { useContext } from 'react';
import { Card } from '@/components/ui/Card';
import { ConfigContext } from '@/context/ConfigContext';
import { Views, type ViewValues } from '@/constants/views';
import { Button } from '@/components/ui/Button';
import {
  ArrowLeft,
  Copy,
  NotePencil,
  Prohibit,
  Trash,
} from '@phosphor-icons/react';

type Props = {
  loading: boolean;
  setSelectedView: (view: ViewValues) => void;
  onCancel: (value: boolean) => void;
};

export function PrivacyOptionsSelector({
  loading,
  setSelectedView,
  onCancel,
}: Props) {
  const {
    privacyRequestsOptionsTitle,
    privacyRequestsDescription,
    changeRequestName,
    viewRequestName,
    deleteRequestName,
    doNotSellRequestEnabled,
    doNotSellRequestName,
  } = useContext(ConfigContext);

  const title = (
    <div className="flex items-center gap-4">
      <ArrowLeft className="cursor-pointer" onClick={() => onCancel(true)} />
      {privacyRequestsOptionsTitle}
    </div>
  );

  return (
    <div>
      <Card loading={loading} title={title}>
        <p className="text-muted-foreground mb-6">
          {privacyRequestsDescription}
        </p>
        <div
          className={`grid grid-cols-1 gap-5 md:grid-cols-2 ${doNotSellRequestEnabled ? '2xl:grid-cols-4' : 'lg:grid-cols-3'}`}
        >
          <div>
            <Button
              className="text-subheader w-full"
              data-testid="cd-view-request-button"
              iconLeft={<Copy className="text-base" />}
              size="lg"
              variant="pc-outline"
              onClick={() => setSelectedView(Views.ComplianceRequestCopy)}
            >
              {viewRequestName}
            </Button>
          </div>
          <div>
            <Button
              className="text-subheader w-full"
              data-testid="cd-change-request-button"
              iconLeft={<NotePencil />}
              size="lg"
              variant="pc-outline"
              onClick={() => setSelectedView(Views.ComplianceRequestChange)}
            >
              {changeRequestName}
            </Button>
          </div>
          <div>
            <Button
              className="text-subheader w-full"
              data-testid="cd-delete-request-button"
              iconLeft={<Trash />}
              size="lg"
              variant="pc-outline"
              onClick={() => setSelectedView(Views.ComplianceRequestDelete)}
            >
              {deleteRequestName}
            </Button>
          </div>
          {doNotSellRequestEnabled ? (
            <div>
              <Button
                className="text-subheader w-full"
                data-testid="cd-dns-request-button"
                iconLeft={<Prohibit />}
                size="lg"
                variant="pc-outline"
                onClick={() =>
                  setSelectedView(Views.ComplianceRequestDoNotSell)
                }
              >
                {doNotSellRequestName}
              </Button>
            </div>
          ) : (
            <></>
          )}
        </div>
      </Card>
    </div>
  );
}
